export default __webpack_public_path__ + "static/media/chris.55bcd419.png";